<template>
    <div class="wrap" :style="{'background-image': 'url('+imgArr[loginImg || 0]+')'}">
        <div class="logo td-fcc">
            <img
                src="@/assets/img/home/web_logo.png"
            >
        </div>
        <div class="logo-box">
            <div class="input-box">
                <div class="input-title">家长登录</div>
                <el-form
                        :model="loginForm"
                        :rules="loginRules"
                        ref="loginForm"
                        class="login-form"
                >
                    <template v-for="(item, index) in formField">
                        <div
                                class="verify-box"
                                v-if="item.field == 'code'"
                                :key="index"
                        >
                            <el-form-item :prop="item.field">
                                <el-input
                                        v-model="loginForm[item.field]"
                                        :placeholder="item.desc"
                                        :suffix-icon="item.icon"
                                        :type="item.form_type"
                                ></el-input>
                            </el-form-item>
                            <div
                                    class="verify-code"
                                    @click="refreshCode"
                            >
                                <s-identify :identifyCode="identifyCode"></s-identify>
                            </div>
                        </div>
                        <el-form-item
                                v-else
                                :key="index"
                                :prop="item.field"
                        >
                            <el-input
                                    v-model="loginForm[item.field]"
                                    :placeholder="item.desc"
                                    :suffix-icon="item.icon"
                                    :type="item.form_type"
                            ></el-input>
                        </el-form-item>
                    </template>

                    <el-form-item>
                        <div class="button-box">
                            <el-button
                                    type="success"
                                    @click="submitForm('loginForm')"
                            >登录
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="no-account">
                <span>没有账户？<el-link @click="$router.push('/parent_register')">去注册</el-link></span>
                <span><el-link @click="$router.push('/')">返回首页</el-link></span>
            </div>
            <p class="hint">
                <span>
                    <i class="el-icon-warning-outline"></i>请保护好账号安全，勿泄漏账号密码
                </span>
            </p>
        </div>
        <div class="wallpaper-box td-fcc">
            <wallpaper></wallpaper>
        </div>
    </div>
</template>

<script>
    import SIdentify from "@/components/Identify";
    import wallpaper from "@/components/wallpaper";
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "index",
        components: {
            SIdentify,
            wallpaper
        },
        computed: {...mapGetters(['loginImg'])},
        data() {
            // 验证码验证规则
            var validateCode = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请输入验证码"));
                } else {
                    if (value !== this.identifyCode) {
                        callback(new Error("验证码错误"));
                    }
                    callback();
                }
            };
            return {
                imgArr: [
                    '/htmlStatic/img/bg_img_1.jpg',
                    '/htmlStatic/img/bg_img_2.jpg',
                    '/htmlStatic/img/bg_img_3.jpg',
                    '/htmlStatic/img/bg_img_4.jpg',
                    '/htmlStatic/img/bg_img_5.jpg',
                    '/htmlStatic/img/bg_img_6.jpg',
                ],
                identifyCode: '',
                loginForm: {
                    emp_no: "",
                    password: "",
                    code: ""
                },
                formField: [
                    {
                        field: "emp_no",
                        form_type: "text",
                        icon: "el-icon-user",
                        desc: "请输入登录账号"
                    },
                    {
                        field: "password",
                        form_type: "password",
                        icon: "el-icon-lock",
                        desc: "请输入登录密码"
                    },
                    {
                        field: "code",
                        form_type: "text",
                        icon: "el-icon-mobile",
                        desc: "请输入验证码"
                    }
                ],
                loginRules: {
                    emp_no: [
                        {
                            required: true,
                            message: "请输入登录账号",
                            trigger: "blur"
                        }
                    ],
                    password: [
                        {
                            required: true,
                            message: "请输入登录密码",
                            trigger: "blur"
                        }
                    ],
                    code: [{validator: validateCode, trigger: "blur"}]
                }
            };
        },
        methods: {
            // 更新验证码
            refreshCode() {
                this.identifyCode = Math.random()
                    .toString(36)
                    .substr(2)
                    .slice(1, 5);
                // this.loginForm.code = this.identifyCode
            },
            // 表单提交
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.requestForm()
                    }
                });
            },
            requestForm() {
                let {code, ...params} = this.loginForm
                let redirect = this.$route.query.redirect
                this.$store
                    .dispatch("ParentLogin", params)
                    .then(res => {
                        this.$router.replace({
                            path: redirect || '/parent'
                        });
                    })
                    .catch((err) => {
                        this.refreshCode()
                    })
            }
        },
        created() {
            this.refreshCode()
        }
    };
</script>
<style lang="less" scoped>
    @import "../../assets/css/form";

    .wrap {
        height: 100vh;
        background-position: center center;
        background-attachment: fixed;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .logo {
        text-align: center;
        padding-top: 40px;
        img{
            display: block;
            height: 75px;
        }
    }

    .logo-box {
        width: 450px;
        padding-bottom: 20px;
        border-radius: 15px;
        background: #fff;
        margin: 20px auto;

        .input-box {
            width: 370px;
            margin: 0 auto;

            .input-title {
                font-size: 24px;
                text-align: center;
                line-height: 100px;
            }
        }

        .hint {
            text-align: center;
            color: #fa4860;
            font-size: 16px;
            margin: 30px auto;
            width: 370px;

            span {
                width: 100%;
                box-sizing: border-box;
                display: inline-block;
                border-radius: 5px;
                padding: 10px 20px;
                background-color: #f3f3f3;
            }
        }

        .button-box {
            display: flex;

            button {
                flex: 1;
            }
        }
    }

    .no-account {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 40px;
        margin-top: 10px;

        span {
            font-size: 14px;
        }
    }
    .wallpaper-box{
        margin-top: 40px;
    }
</style>